import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { base } from "@components/card/CardButton.styles";
export { icon } from "@components/card/CardButton.styles";
import { greys, helpers } from "@clockwise/web-commons/src/styles/color.styles";

const syncing: CSSProperties = {
  padding: `5px 6px 10px`,
  color: "white",
  fontSize: 14,
  lineHeight: 1.4,
  WebkitFontSmoothing: "antialiased",
};

const button: CSSProperties = {
  ...base,
  color: greys.white,
  padding: "8px 0",
  "&:hover": {
    backgroundColor: helpers.opacity(greys.darkGreyBlue, 0.1),
  },
};

export const styles = {
  syncing,
  button,
};
